var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.video'] = (function () {
    'use strict';

    const CONFIG = {
        VIDEO_SELECTOR: ".partial-video",
        PLAY_SELECTOR: ".partial-video__button",
        PLACEHOLDER_SELECTOR: ".partial-video__placeholder",
        SOURCE_ATTRIBUTE: "data-src",
        TITLE_ATTRIBUTE: "data-title"
    };

    // Initializes video component event listeners
    const initialize = (video) => {

        // attach event listener for individual video's play button
        const playButton = video.querySelector(CONFIG.PLAY_SELECTOR);
        playButton.addEventListener("click", function () {
            play(video);
        });

        // attach event listener for stopping video in a modal: stop video when modal is closed
        const modalElement = video.closest(".modal");
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
            modalElement.addEventListener('hidden.bs.modal', function (event) {
                stop(video);
            });
        }
    }

    // Plays the selected video and stops others
    const play = (video) => {

        // stop all videos before starting intended video
        const videos = document.querySelectorAll(CONFIG.VIDEO_SELECTOR);
        videos.forEach(video => { stop(video); });

        // play the intended video
        const target = video.querySelector(CONFIG.PLACEHOLDER_SELECTOR);
        const button = video.querySelector(CONFIG.PLAY_SELECTOR);
        const source = button?.getAttribute(CONFIG.SOURCE_ATTRIBUTE);
        const title = button?.getAttribute(CONFIG.TITLE_ATTRIBUTE);

        let iframe = null;
        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                iframe = getYoutubeIframe(source, title);
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                iframe = getVimeoIframe(source, title);
                break;
            default:
                console.log("Could not locate video content");
                return;
        };

        target.replaceChildren(iframe);
        button.style.display = "none";
        target.style.display = "block";

        // the play button that had focus is now hidden; hand focus to the player so keyboard users aren't dropped to the top of the page (WCAG 2.4.3)
        iframe.focus();
    }

    // Stops the video and resets the UI
    const stop = (video) => {
        const target = video.querySelector(CONFIG.PLACEHOLDER_SELECTOR);
        const button = video.querySelector(CONFIG.PLAY_SELECTOR);

        target.style.display = "none";
        target.replaceChildren();
        button.style.display = "block";
    }

    // Builds the embed iframe as an element, so a CMS title containing quotes can't break the markup,
    // and always gives it an accessible name (WCAG 4.1.2)
    const createIframe = (source, title, allow) => {
        const iframe = document.createElement("iframe");
        iframe.src = source;
        iframe.title = title || "Video player";
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allow", allow);
        iframe.setAttribute("allowfullscreen", "");
        return iframe;
    }

    // Returns a YouTube embed iframe
    const getYoutubeIframe = (source, title) => {
        return createIframe(source, title, "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
    }

    // Returns a Vimeo embed iframe
    const getVimeoIframe = (source, title) => {
        return createIframe(source, title, "autoplay; fullscreen; picture-in-picture");
    }

    return {
        initialize
    };

})();